// extracted by mini-css-extract-plugin
export default {"footer":"Footer-footer-WQb","footerCta":"Footer-footerCta-WM4","footerCtaBlack":"Footer-footerCtaBlack-FwF"};